import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { useModalCrudState } from '../../../_helper/hooks/useModalCrudState';

const initialFormData = {
    title: '',
    text: '',
    isActive: true,
};

const AnnouncementDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedAnnouncement, refreshData }) => {
    const customHandlers = useMemo(() => ({
        isActive: (value, prev) => ({ ...prev, isActive: value === 'true' }),
    }), []);

    const validationSchema = useMemo(() => ({
        title: { required: true, message: 'Başlık zorunludur.' },
        text: { required: true, message: 'Açıklama zorunludur.' },
    }), []);

    const {
        formData,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode,
        selectedItem: selectedAnnouncement,
        initialData: initialFormData,
        toggle,
        mapSelectedToData: ({ initialData, selectedItem }) => ({
            ...initialData,
            title: selectedItem?.title || '',
            text: selectedItem?.text || '',
            isActive: typeof selectedItem?.isActive === 'boolean' ? selectedItem.isActive : true,
        }),
        normalizeInput: true,
        customHandlers,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            refreshData,
            componentName: 'Duyuru',
        },
    });

    const getModalTitle = () => (mode === 'add' ? 'Yeni Duyuru Ekle' : 'Duyuru Düzenle');
    const getButtonLabel = () => (mode === 'add' ? 'Ekle' : 'Güncelle');

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} size="lg">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <Form>
                <ModalBody>
                    <FormGroup>
                        <Label for="title">Başlık <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            name="title"
                            id="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            required
                            disabled={isSubmitting}
                            placeholder="Duyuru başlığını girin"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="text">Açıklama <span className="text-danger">*</span></Label>
                        <Input
                            type="textarea"
                            name="text"
                            id="text"
                            rows="4"
                            value={formData.text}
                            onChange={handleInputChange}
                            required
                            disabled={isSubmitting}
                            placeholder="Duyuru içeriğini girin"
                        />
                    </FormGroup>
                    <FormGroup className="d-flex align-items-center mb-3">
                        <Label className="me-3" style={{ minWidth: '100px' }}>Durum</Label>
                        <div className="d-flex">
                            <div className="radio radio-success me-3 d-flex align-items-center">
                                <Input
                                    id="isActiveTrue"
                                    type="radio"
                                    name="isActive"
                                    value="true"
                                    checked={formData.isActive === true}
                                    onChange={handleInputChange}
                                    disabled={isSubmitting}
                                />
                                <Label htmlFor="isActiveTrue" className="ms-1 mb-0">Aktif</Label>
                            </div>
                            <div className="radio radio-danger d-flex align-items-center">
                                <Input
                                    id="isActiveFalse"
                                    type="radio"
                                    name="isActive"
                                    value="false"
                                    checked={formData.isActive === false}
                                    onChange={handleInputChange}
                                    disabled={isSubmitting}
                                />
                                <Label htmlFor="isActiveFalse" className="ms-1 mb-0">Pasif</Label>
                            </div>
                        </div>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="outline-success" className="rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? 'Kaydediliyor...' : getButtonLabel()}
                    </Button>
                    <Button color="outline-danger" className="ms-2 rounded-pill" onClick={handleCancel} disabled={isSubmitting}>
                        İptal
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default AnnouncementDataModal;
